
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 1000 801.11"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M598.18 92a16.65 16.65 0 00-1-1.51h.29zM598.4 111.12a18.75 18.75 0 01-1.27 1.92zM912.9 347.14l-56-20.41-82.32-147.53 34.09-84.59s3.82-7.88 6.4-14.73l135.66 281-23-8.33zM559.58 720.5a80.58 80.58 0 01-79 80.59H78.18a80.61 80.61 0 010-161.22h402.45a80.6 80.6 0 0178.95 80.63zM480.6 639.89h-1.63zM479 801.11h1.63zM560.08 601.25H-2.43V418.73h257.6V236.22h177.5l127.41 365.03z"}}),_c('path',{attrs:{"d":"M598.18 92a16.65 16.65 0 00-1-1.51h.29zM597.13 113l1.27-1.92a18.75 18.75 0 01-1.27 1.92zM599.85 95.49L598.18 92a20 20 0 011.67 3.49zM790 27.84l-3.59-7.41a34.24 34.24 0 00-2.19-3.25 42.27 42.27 0 00-13.66-12 41.57 41.57 0 00-50.92 8.5l-1.94 2.21-1.07 2-15.57 29.45-175.2 332L540.42 421l50 140.11 165-416.41 36-90.81a45 45 0 001.33-11.08A43.2 43.2 0 00790 27.84zm-5.84 37.69l2.73-4.12a40.25 40.25 0 01-2.77 4.12z"}}),_c('path',{attrs:{"d":"M525.86 379.31l14.56 41.71-14.75-41.34.19-.37zM597.13 113l1.27-1.92a18.75 18.75 0 01-1.27 1.92zM599.85 95.49L598.18 92a20 20 0 011.67 3.49zM1000 490.49q0 4.31-.32 8.57a110.79 110.79 0 01-110.44 102.19H731.88l49.38-135.7v-.09l9.22-25.3 22-60.48 11.15-30.61 57.28 20.83 26.83 9.75 10.83 3.95 16.81 6.1a110.88 110.88 0 0163.17 83c.26 2.56.58 5.09 1 7.63.3 3.35.45 6.72.45 10.16z"}}),_c('path',{attrs:{"d":"M598.4 111.12a18.75 18.75 0 01-1.27 1.92z"}})])
          )
        }
      }
    